
(function () {
  const startTime = Date.now();
  const interval = setInterval(() => {
    if (Date.now() - startTime > 15000) { clearInterval(interval); return; }
    const offer = window.tlFreeGiftOffer;
    if (!offer || !offer.storefrontApi || typeof offer.fetchNextCollectionGift !== "function") return;
    clearInterval(interval);

    const api = offer.storefrontApi;
    if (api._neroliCollPatched) return;
    api._neroliCollPatched = true;

    const ROW_PER_PAGE = offer.constants?.ROW_PER_PAGE || 5;
    const API_VERSION = offer.constants?.API_VERSION || "2025-01";

    // cờ hideOOS của rule đang fetch (getCollectionData không nhận rule)
    const origFetchNext = offer.fetchNextCollectionGift.bind(offer);
    offer.fetchNextCollectionGift = function (rule) {
      offer._neroliAvailableOnly = !!(rule && rule.hide_gift_out_of_stock);
      return origFetchNext(rule);
    };

    const origGetCollectionData = api.getCollectionData.bind(api);

    async function fetchFiltered(nonGlobalId, endCursor) {
      const res = await fetch(`https://${Shopify.shop}/api/${API_VERSION}/graphql.json`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Shopify-Storefront-Access-Token": offer.storeAccessToken },
        body: JSON.stringify({
          query: `query ($endCursor: String){
            collection(id: "gid://shopify/Collection/${nonGlobalId}") {
              products(first: ${ROW_PER_PAGE}, after: $endCursor, filters: [{ available: true }]) {
                nodes { id title handle featuredImage { url } availableForSale
                  variants(first: 100) { nodes { id title availableForSale image { url } price { amount currencyCode } } } }
                pageInfo { hasNextPage endCursor }
              }
            }
          }`,
          variables: { endCursor }
        })
      });
      const json = await res.json();
      if (json?.errors) { console.warn("[NEROLI] filter lỗi, fallback:", json.errors); return origGetCollectionData(nonGlobalId, endCursor); }
      return json.data ?? null;
    }

    const cache = new Map();
    api.getCollectionData = function (nonGlobalId, endCursor) {
      const filtered = !!offer._neroliAvailableOnly;
      const key = `${nonGlobalId}::${endCursor ?? "null"}::${filtered ? "A" : "F"}`;
      if (cache.has(key)) return cache.get(key);

      const p = (async () => {
        try { return filtered ? await fetchFiltered(nonGlobalId, endCursor) : await origGetCollectionData(nonGlobalId, endCursor); }
        catch (e) { console.error("[NEROLI] getCollectionData lỗi:", e); return null; }
      })();
      p.then((d) => { if (d == null) cache.delete(key); }).catch(() => cache.delete(key));
      cache.set(key, p);
      return p;
    };

    console.log("[NEROLI] collection fetch: dedupe + available-filter ON");
  }, 100);
})();
